import { ArrowTriangleIcon } from '@honestica/curecall-ui'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import { useTranslation } from 'react-i18next'

export const AuthBackButton = () => {
  const navigate = useLocalizedNavigate()
  const { t } = useTranslation()

  return (
    <button onClick={() => navigate('/login')} className="c-flex c-justify-start">
      <div className="c-flex c-items-center c-gap-1 c-font-semibold c-text-primary-600">
        <ArrowTriangleIcon className="c-h-4 c-w-4" position="LEFT" />
        <span>{t('pages.auth.cta.back-to-connexion-page')}</span>
      </div>
    </button>
  )
}
